import { Typography } from "@mui/material";
import { FC } from "react";

interface MissionProgressColumnProps {
  currentProgress?: number;
  totalProgress?: number;
  isMissionOngoing: boolean;
}

const MissionProgressColumn: FC<MissionProgressColumnProps> = ({
  currentProgress,
  totalProgress,
  isMissionOngoing,
}) => {
  if ((isMissionOngoing && totalProgress) ?? 0 > 0) {
    return (
      <Typography>
        {currentProgress} / {totalProgress}
      </Typography>
    );
  }

  return <Typography>-</Typography>;
};

export default MissionProgressColumn;
